// extracted by mini-css-extract-plugin
export default {"actions":"actions---nScam","unassignAll":"unassignAll---oYxzR"};